import { z } from 'zod';
import { apiGet, apiSend } from '@/lib/api';

/**
 * DOZÓR PLIKÓW LOGÓW SPS.
 *
 * ⚠️ PO CO TO JEST: awaria SupplyPointa nie zgłasza się w portalu w żaden sposób — agent widzi bazę,
 * nie program. Ślad zostaje wyłącznie na maszynie (`FatalErrors.log`, znaczniki `APPCRASH_SPSUI_*`),
 * a tam nikt nie zagląda, dopóki nie ma powodu.
 */

export const PlikLoguSchema = z.object({
  klucz: z.string(),
  plik: z.string(),
  opis: z.string(),
  gdzie: z.string(),
  monitoruj: z.boolean(),
  alarmuj: z.boolean(),
  /** Czy agent przysyła TREŚĆ dopisaną do pliku — osobna zgoda, bo treść opuszcza maszynę klienta. */
  ogon: z.boolean(),
  domyslnie: z.object({ monitoruj: z.boolean(), alarmuj: z.boolean(), ogon: z.boolean() }),
});

export type PlikLogu = z.infer<typeof PlikLoguSchema>;

export const UstawieniaLogowSchema = z.object({
  pliki: z.array(PlikLoguSchema),
  dniPrzechowywania: z.number(),
});

export const ZmianaLoguSchema = z.object({
  id: z.string(),
  nodeId: z.string(),
  klucz: z.string(),
  plik: z.string(),
  sciezka: z.string(),
  rodzaj: z.string(),
  rozmiarPrzed: z.number().nullable(),
  rozmiarPo: z.number().nullable(),
  mtime: z.string().nullable(),
  fragment: z.string().nullable(),
  uciety: z.boolean(),
  at: z.string(),
});

export type ZmianaLogu = z.infer<typeof ZmianaLoguSchema>;

export const PrzegladLogowSchema = z.object({
  dni: z.number(),
  dniPrzechowywania: z.number(),
  zmiany: z.array(ZmianaLoguSchema),
  poPliku: z.array(z.object({ klucz: z.string(), plik: z.string(), ile: z.number() })),
});

export const fetchUstawieniaLogow = (groupId: string) =>
  apiGet(`/logi-sps/ustawienia?groupId=${groupId}`, UstawieniaLogowSchema);

export const ustawLogSps = (
  groupId: string,
  klucz: string,
  wartosci: { monitoruj: boolean; alarmuj: boolean; ogon: boolean },
) =>
  apiSend(
    'PUT',
    '/logi-sps/ustawienia',
    { groupId, klucz, ...wartosci },
    z.object({ klucz: z.string(), monitoruj: z.boolean(), alarmuj: z.boolean(), ogon: z.boolean() }),
  );

export const fetchZmianyLogow = (groupId: string, dni: number, klucz?: string) =>
  apiGet(
    `/logi-sps?groupId=${groupId}&dni=${dni}${klucz === undefined ? '' : `&klucz=${encodeURIComponent(klucz)}`}`,
    PrzegladLogowSchema,
  );
